export const videos = [
  {
    id: 1,
    title: '长风渡',
    category: 'dianshiju',
    categoryName: '电视剧',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20poster%20with%20elegant%20couple%20in%20traditional%20hanfu%20robes%2C%20warm%20golden%20lighting%2C%20ancient%20Chinese%20architecture%20background%2C%20cinematic%20composition%2C%20soft%20atmospheric%20mood&width=800&height=450&seq=video-01&orientation=landscape',
    rating: 9.2,
    year: 2024,
    episodes: 40,
    status: '已完结',
    description: '讲述了布商之女柳玉茹与纨绔子弟顾九思从互相抵触到携手共进的成长故事。',
    featured: true,
    hot: true,
    new: false,
  },
  {
    id: 2,
    title: '庆余年第二季',
    category: 'dianshiju',
    categoryName: '电视剧',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20drama%20poster%20featuring%20male%20lead%20in%20dark%20elegant%20robe%2C%20mysterious%20atmosphere%2C%20ancient%20palace%20silhouette%20background%2C%20dramatic%20lighting%2C%20cinematic%20film%20poster%20style&width=800&height=450&seq=video-02&orientation=landscape',
    rating: 9.5,
    year: 2024,
    episodes: 36,
    status: '更新至28集',
    description: '范闲身世之谜逐渐揭开，各方势力暗流涌动，京都风云再起。',
    featured: true,
    hot: true,
    new: true,
  },
  {
    id: 3,
    title: '与凤行',
    category: 'dianshiju',
    categoryName: '电视剧',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20drama%20poster%20with%20female%20warrior%20in%20flowing%20red%20dress%2C%20phoenix%20motif%2C%20ethereal%20cloud%20background%2C%20magical%20atmosphere%2C%20cinematic%20lighting&width=800&height=450&seq=video-03&orientation=landscape',
    rating: 9.0,
    year: 2024,
    episodes: 39,
    status: '已完结',
    description: '魔界女王爷沈璃与上古神君行止的宿命轮回之恋。',
    featured: false,
    hot: true,
    new: false,
  },
  {
    id: 4,
    title: '流浪地球3',
    category: 'dianying',
    categoryName: '电影',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20massive%20spaceship%20and%20earth%20in%20background%2C%20futuristic%20technology%2C%20dramatic%20space%20scene%2C%20cinematic%20composition%2C%20epic%20scale&width=800&height=450&seq=video-04&orientation=landscape',
    rating: 9.3,
    year: 2025,
    episodes: 1,
    status: 'HD高清',
    description: '人类命运共同体面临新的考验，流浪地球计划进入关键阶段。',
    featured: true,
    hot: true,
    new: true,
  },
  {
    id: 5,
    title: '热辣滚烫',
    category: 'dianying',
    categoryName: '电影',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%20with%20warm%20vibrant%20colors%2C%20female%20lead%20showing%20determination%2C%20boxing%20theme%2C%20inspiring%20atmosphere%2C%20modern%20urban%20setting&width=800&height=450&seq=video-05&orientation=landscape',
    rating: 8.8,
    year: 2024,
    episodes: 1,
    status: 'HD高清',
    description: '一个普通女孩通过拳击找到自我、实现蜕变的励志故事。',
    featured: false,
    hot: true,
    new: false,
  },
  {
    id: 6,
    title: '飞驰人生2',
    category: 'dianying',
    categoryName: '电影',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20racing%20comedy%20movie%20poster%20with%20race%20car%20on%20track%2C%20dynamic%20action%20scene%2C%20desert%20racing%20backdrop%2C%20cinematic%20motion%20blur%2C%20intense%20atmosphere&width=800&height=450&seq=video-06&orientation=landscape',
    rating: 8.7,
    year: 2024,
    episodes: 1,
    status: 'HD高清',
    description: '昔日车神重出江湖，这一次他要为尊严而战。',
    featured: false,
    hot: false,
    new: true,
  },
  {
    id: 7,
    title: '斗罗大陆2',
    category: 'dongman',
    categoryName: '动漫',
    image: 'https://readdy.ai/api/search-image?query=Chinese%203D%20anime%20poster%20with%20young%20hero%20in%20martial%20arts%20pose%2C%20magical%20blue%20spirit%20energy%2C%20fantasy%20landscape%20background%2C%20dynamic%20composition%2C%20vibrant%20colors&width=800&height=450&seq=video-07&orientation=landscape',
    rating: 9.1,
    year: 2024,
    episodes: 52,
    status: '更新至35集',
    description: '唐三进入新的修炼阶段，更强大的敌人与更深邃的秘密等待着他。',
    featured: true,
    hot: true,
    new: false,
  },
  {
    id: 8,
    title: '完美世界',
    category: 'dongman',
    categoryName: '动漫',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20anime%20poster%20with%20ancient%20mythological%20style%2C%20powerful%20male%20character%20with%20glowing%20aura%2C%20epic%20battle%20background%2C%20fantasy%20world%20setting%2C%20dramatic%20lighting&width=800&height=450&seq=video-08&orientation=landscape',
    rating: 9.0,
    year: 2024,
    episodes: 78,
    status: '更新至60集',
    description: '石昊历经磨难，一步步走向至强者之路的传奇故事。',
    featured: false,
    hot: true,
    new: false,
  },
  {
    id: 9,
    title: '奔跑吧第12季',
    category: 'zongyi',
    categoryName: '综艺',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20group%20of%20celebrities%20laughing%20and%20running%20outdoors%2C%20colorful%20vibrant%20design%2C%20energetic%20atmosphere%2C%20bright%20sunny%20day%2C%20fun%20composition&width=800&height=450&seq=video-09&orientation=landscape',
    rating: 8.5,
    year: 2024,
    episodes: 12,
    status: '更新至6期',
    description: '全新一季跑男团带来更多欢笑与感动的户外竞技挑战。',
    featured: false,
    hot: false,
    new: true,
  },
  {
    id: 10,
    title: '舌尖上的中国5',
    category: 'jilupian',
    categoryName: '纪录片',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%20with%20beautiful%20traditional%20Chinese%20cuisine%20closeup%2C%20steaming%20hot%20dishes%2C%20warm%20kitchen%20atmosphere%2C%20artistic%20food%20photography%2C%20rich%20colors&width=800&height=450&seq=video-10&orientation=landscape',
    rating: 9.4,
    year: 2024,
    episodes: 8,
    status: '已完结',
    description: '探寻中国各地最地道的美食文化，品味舌尖上的中国故事。',
    featured: false,
    hot: false,
    new: false,
  },
  {
    id: 11,
    title: '繁花',
    category: 'dianshiju',
    categoryName: '电视剧',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20set%20in%201990s%20Shanghai%2C%20elegant%20retro%20style%2C%20neon%20lights%2C%20stylish%20characters%2C%20nostalgic%20atmosphere%2C%20cinematic%20quality&width=800&height=450&seq=video-11&orientation=landscape',
    rating: 9.3,
    year: 2024,
    episodes: 30,
    status: '已完结',
    description: '九十年代的上海，阿宝在商海沉浮中书写了一段传奇人生。',
    featured: true,
    hot: false,
    new: false,
  },
  {
    id: 12,
    title: '封神第二部',
    category: 'dianying',
    categoryName: '电影',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20epic%20movie%20poster%20with%20ancient%20gods%20and%20warriors%2C%20grand%20battle%20scene%2C%20dramatic%20sky%2C%20Chinese%20mythology%20theme%2C%20cinematic%20scale&width=800&height=450&seq=video-12&orientation=landscape',
    rating: 9.1,
    year: 2025,
    episodes: 1,
    status: 'HD高清',
    description: '封神大战全面爆发，姜子牙率领众仙迎战纣王的终极对决。',
    featured: false,
    hot: true,
    new: true,
  },
];

export const getVideosByCategory = (categorySlug: string) => {
  return videos.filter((v) => v.category === categorySlug);
};

export const getFeaturedVideos = () => {
  return videos.filter((v) => v.featured);
};

export const getHotVideos = () => {
  return videos.filter((v) => v.hot);
};

export const getNewVideos = () => {
  return videos.filter((v) => v.new);
};

export const getVideoById = (id: number) => {
  return videos.find((v) => v.id === id);
};